var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 10 10"
      }
    },
    [
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.color,
          "stroke-width": _vm.strokeWidth,
          d: "M.7071.70705L9.1761 9.17605M.7071 9.17585L9.1761.70685"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }